import ContactNote from './ContactNote';

export default ContactNote;
